import React, { useEffect, useMemo, useRef, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // สำคัญ: ตัวนี้มี Popper แล้ว

// import { setDoc, doc as fsDoc, serverTimestamp } from "firebase/firestore";
import { runTransaction, setDoc as setDocFS, doc as fsDoc, getDoc, collection, serverTimestamp, getDocs, writeBatch, } from "firebase/firestore";
import { useAuth } from "../../../../shared/auth/AuthProvider";
import { db } from "../../../../shared/libs/firebaseConfig";
import { useNavigate, useParams, Link } from "react-router-dom";

import { Container } from "react-bootstrap";
import { toArticleDoc } from "../../../../shared/utils/articleTransforms";
import { reserveUniqueSlug } from "../../../../shared/utils/reserveSlug";
import { uploadImage } from "../../../../shared/utils/uploader";

import { BsUpload } from "react-icons/bs";

/**
 * Encraft Article Editor – React + Bootstrap (single-file mockup)
 *
 * How to use:
 * - Drop this file into your React app (e.g., src/ArticleEditor.js) and import it in a route/page.
 * - Ensure Bootstrap CSS/JS is loaded in your app (e.g., via index.html or imports).
 * - This mockup focuses on UX flow and data structure; wire Firestore calls where indicated.
 */

// ===== Category Master (ปรับแก้ได้ตามนโยบายเว็บ) =====
export const CATEGORIES = {
  "เนติบัณฑิต": [
    "บทบรรณาธิการ",
    "แนวข้อสอบ",
    "ฎีกาเกร็ง",
    "สถิติข้อสอบ",
  ],

  "ทนายความ": [
    "แนวข้อสอบ",
    "ฎีกาเกร็ง",
    "สถิติข้อสอบ",
  ],

  "อัยการ": [
    "แนวข้อสอบ",
    "ฎีกาเด็ด",
  ],

  "ผู้พิพากษา": [
    "แนวข้อสอบ",
    "ฎีกาเด็ด",
  ],

};
export const OTHER_VALUE = "__OTHER__";

export default function ArticleEditor() {

  const { articleId } = useParams();

  const { user, loading } = useAuth();

  // ===== Preview Modal =====
  const [showPreview, setShowPreview] = useState(false);

  // ===== Article Archived/Delete Modal =====
  const navigate = useNavigate();
  const [showArchiveConfirm, setShowArchiveConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showRestoreConfirm, setShowRestoreConfirm] = useState(false);

  // ===== Root Document State (mapped to /articles/{articleId}) =====
  const EMPTY_DOC = {
    articleId: "",
    slug: "",
    title: "",
    subtitle: "",
    status: "draft", // draft | published | archived
    category: "",
    subCategory: "",
    tags: [],
    author: { uid: "", displayName: "" },
    level: "general", // general | beginner | intermediate | advanced
    cover: {
      imageUrl: "",
      alt: "",
      width: null,
      height: null,
    },
    blocks: [],
    readTime: 0,
    wordCount: 0,
    publicStatus: true,

    // ✅ เพิ่มตรงนี้
    views: 0,
    // ถ้าอยากเผื่อไว้: likesCount / bookmarksCount ด้วย
    likesCount: 0,
    bookmarksCount: 0,
  };

  const [docState, setDocState] = useState(() => EMPTY_DOC);

  // โหลด / สร้างบทความ จาก articleId ใน URL
  useEffect(() => {
    let isCanceled = false;

    const loadArticle = async () => {
      try {
        suppressAutoSave.current = true;

        if (!articleId) {
          console.error("No articleId in URL");
          return;
        }

        // ถ้ายังโหลด user จาก Auth อยู่ → รอ
        if (loading) return;

        // ยังไม่ login → เตะไปหน้า login
        if (!user) {
          alert("กรุณาเข้าสู่ระบบก่อนเขียนบทความ");
          navigate("/account/login", { replace: true });
          return;
        }

        const ref = fsDoc(db, "articles", articleId);
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          console.warn("article not found:", articleId);
          alert("ไม่พบบทความนี้ในระบบ");
          return;
        }

        const data = snap.data();
        const loadedState = fromFirestoreDoc(articleId, data);

        if (isCanceled) return;

        // รีเซ็ต baseline autosave
        isFirstRender.current = true;
        setDocState(loadedState);
        lastSavedSnapshot.current = buildPayloadNoTimestamps(loadedState);
      } catch (err) {
        console.error("load article error:", err);
        alert("โหลดบทความไม่สำเร็จ: " + (err.message || "unknown"));
      } finally {
        suppressAutoSave.current = false;
      }
    };

    loadArticle();

    return () => {
      isCanceled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleId, user, loading, navigate]);




  // ===== Derived Metrics =====
//   const wordCount = useMemo(() => calcWordCount(docState.blocks), [docState.blocks]);
  const wordCount = useMemo(() => calcWordCountTHAware(docState.blocks), [docState.blocks]);
  const readTime = useMemo(() => Math.max(1, Math.ceil(wordCount / 200)), [wordCount]);

  // Keep metrics in doc for display (optional)
  useEffect(() => {
    setDocState((d) => ({ ...d, wordCount, readTime }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wordCount, readTime]);

  // ===== Autosave =====
  // ===== Autosave (Real) =====
  const [saveState, setSaveState] = useState("idle"); // idle | saving | saved | error
  const [saveError, setSaveError] = useState(null);
  const saveTimer = useRef(null);
  const isFirstRender = useRef(true);
  const suppressAutoSave = useRef(false);
  const lastSavedSnapshot = useRef(null); // เก็บ payload ครั้งล่าสุดที่เซฟสำเร็จ (ไม่รวม timestamp)
  const hasCreatedRef = useRef(false);

  // สร้าง payload พร้อม sanitize (ไม่ใส่ updatedAt/createdAt เพื่อใช้เทียบความเปลี่ยนแปลง)
  const buildPayloadNoTimestamps = (state) => {
    const raw = toArticleDoc(state);
    // ตัดค่า timestamp ออกก่อนเทียบ diff
    const { createdAt, updatedAt, publishedAt, ...rest } = raw || {};
    return sanitizeForFirestore(rest);
  };

  // ===== Autosave Effect (debounce 1.2s) =====
  // ===== Autosave Effect (debounce 1.2s) =====
  useEffect(() => {
    // ถ้ายังไม่มี articleId จริง ๆ → ยังไม่ต้อง autosave
    if (!docState.articleId) return;

    // ข้ามครั้งแรก → ใช้เป็น baseline เฉย ๆ
    if (isFirstRender.current) {
      isFirstRender.current = false;
      lastSavedSnapshot.current = buildPayloadNoTimestamps(docState);
      return;
    }

    // ถ้ากำลังทำงานพิเศษ (load/create/publish/archive/delete) → ไม่ autosave
    if (suppressAutoSave.current) return;

    // เทียบ snapshot ว่าเปลี่ยนจริงไหม
    const currentSnapshot = buildPayloadNoTimestamps(docState);
    const prev = JSON.stringify(lastSavedSnapshot.current || {});
    const curr = JSON.stringify(currentSnapshot || {});
    if (prev === curr) return;

    if (saveTimer.current) clearTimeout(saveTimer.current);
    setSaveState("saving");

    saveTimer.current = setTimeout(() => {
      saveDraftSilent({ showAlert: false });
    }, 1200);

    return () => clearTimeout(saveTimer.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [docState]);


  // ฟังก์ชันเซฟเงียบ ๆ (ใช้ทั้ง autosave และปุ่ม Save Draft)
  const saveDraftSilent = async ({ showAlert = false } = {}) => {
    if (!docState.articleId) {
      console.warn("[Autosave] skip: no articleId");
      return;
    }
    try {
      setSaveError(null);
      setSaveState("saving");

      const ref = fsDoc(db, "articles", docState.articleId);
      const basePayload = toArticleDoc(docState);

      // ใส่ timestamp เมื่อเขียนจริง
      const payload = sanitizeForFirestore({
        ...basePayload,
        status: basePayload.status || "draft",
        createdAt: docState.createdAt || serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      await setDocFS(ref, payload, { merge: true });

      // อัปเดต snapshot ล่าสุด (ไว้กันเขียนซ้ำโดยไม่จำเป็น)
      lastSavedSnapshot.current = buildPayloadNoTimestamps(docState);

      setSaveState("saved");
      if (showAlert) alert("บันทึกเรียบร้อย");
    } catch (err) {
      console.error("[Autosave] error:", err);
      setSaveError(err?.message || "unknown");
      setSaveState("error");
      if (showAlert) alert("บันทึกไม่สำเร็จ: " + (err?.message || "unknown"));
    } finally {
      // รีเซ็ตสถานะกลับ idle ภายหลังเล็กน้อย
      setTimeout(() => setSaveState("idle"), 1200);
    }
  };

  // ===== Handlers =====
  const updateField = (patch) => setDocState((d) => ({ ...d, ...patch }));
  const updateBlock = (id, patch) =>
    setDocState((d) => ({
      ...d,
      blocks: d.blocks.map((b) => (b.id === id ? { ...b, ...patch } : b)),
    }));
  const removeBlock = (id) => setDocState((d) => ({ ...d, blocks: d.blocks.filter((b) => b.id !== id) }));
  const addBlock = (type) => {
    const id = "b" + Math.random().toString(36).slice(2, 7);
    const base = { id, type, data: {} };
    switch (type) {
      case "heading":
        base.data = { level: 2, text: "หัวข้อใหม่" };
        break;
      case "paragraph":
        base.data = { text: "พิมพ์ข้อความย่อหน้าที่นี่..." };
        break;
      case "image":
        base.data = { imageUrl: "", alt: "" };
        break;
      /* case "code":
        base.data = { language: "javascript", code: "// พิมพ์โค้ดที่นี่" };
        break; */
      case "quote":
        base.data = { text: "ใส่คำคม/ข้อความอ้างอิง", cite: "ผู้เขียน" };
        break;
      default:
        break;
    }
    setDocState((d) => ({ ...d, blocks: [...d.blocks, base] }));
  };
  const moveBlock = (id, dir) => {
    setDocState((d) => {
      const idx = d.blocks.findIndex((b) => b.id === id);
      if (idx < 0) return d;
      const newBlocks = [...d.blocks];
      const swapWith = dir === "up" ? idx - 1 : idx + 1;
      if (swapWith < 0 || swapWith >= newBlocks.length) return d;
      [newBlocks[idx], newBlocks[swapWith]] = [newBlocks[swapWith], newBlocks[idx]];
      return { ...d, blocks: newBlocks };
    });
  };

  function isPlainObject(v) {
    return typeof v === "object" && v !== null && Object.getPrototypeOf(v) === Object.prototype;
  }

  function sanitizeForFirestore(input) {
    if (Array.isArray(input)) {
      return input
        .map((v) => sanitizeForFirestore(v))
        .filter((v) => v !== undefined); // ตัด undefined ใน array ทิ้ง
    }
    if (isPlainObject(input)) {
      const out = {};
      for (const [k, v] of Object.entries(input)) {
        if (v === undefined) continue;                // ตัด undefined
        if (typeof v === "number" && Number.isNaN(v)) continue; // ตัด NaN
        out[k] = sanitizeForFirestore(v);
      }
      return out;
    }
    // อื่นๆ (string/number/boolean/Date/Firestore FieldValue/Timestamp) ปล่อยผ่าน
    return input;
  }

  // ===== Actions =====
  /* const onSaveDraft = () => {
    console.log("[SaveDraft]", doc);
    alert("บันทึกฉบับร่างเรียบร้อย (mock)");
  };
  const onPublish = () => {
    setDoc((d) => ({ ...d, status: "published" }));
    alert("เผยแพร่บทความแล้ว (mock)\nstatus = published");
  }; */

  /* const onSaveDraft = async () => {
    try {
      const ref = fsDoc(db, "articles", docState.articleId || docState.articleId);
      const payload = toArticleDoc(docState);

      // ถ้ายังไม่เคยสร้าง เใส่ createdAt ครั้งแรก
      const withTimes = {
        ...payload,
        status: payload.status || "draft",
        createdAt: docState.createdAt || serverTimestamp(),
        updatedAt: serverTimestamp(),
      };

      await setDocFS(ref, withTimes, { merge: true });
      alert("บันทึกฉบับร่างเรียบร้อย");
    } catch (e) {
      console.error(e);
      alert("บันทึกไม่สำเร็จ: " + (e?.message || "unknown"));
    }
  };

  const onPublish = async () => {
    try {
      const articleId = docState.articleId;
      const desired = (docState.slug?.trim() || docState.title || "post");
      const finalSlug = await reserveUniqueSlug(db, articleId, desired);

      const ref = fsDoc(db, "articles", articleId);
      const payload = toArticleDoc({ ...docState, slug: finalSlug });

      await setDocFS(ref, {
        ...payload,
        status: "published",
        slug: finalSlug,
        publishedAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      }, { merge: true });

      alert("เผยแพร่บทความแล้ว\nslug = " + finalSlug);
    } catch (e) {
      console.error(e);
      alert("เผยแพร่ไม่สำเร็จ: " + (e?.message || "unknown"));
    }
  }; */

  // Save Draft
  /* const onSaveDraft = async () => {
    try {

    const ref = fsDoc(db, "articles", docState.articleId || docState.articleId);
    const payloadRaw = toArticleDoc(docState);
    const withTimesRaw = {
        ...payloadRaw,
        status: payloadRaw.status || "draft",
        createdAt: docState.createdAt || serverTimestamp(),
        updatedAt: serverTimestamp(),
      };
    const withTimes = sanitizeForFirestore(withTimesRaw);


    await setDocFS(ref, withTimes, { merge: true });

      alert("บันทึกฉบับร่างเรียบร้อย");
    } catch (e) {
      console.error(e);
      alert("บันทึกไม่สำเร็จ: " + (e?.message || "unknown"));
    }
  }; */
  const onSaveDraft = async () => {
    if (!docState.articleId) {
      alert("ยังไม่มี Article ID ไม่สามารถบันทึกได้");
      return;
    }
    await saveDraftSilent({ showAlert: true });
  };

  // Publish
  const onPublish = async () => {
    try {
      suppressAutoSave.current = true;
      setSaveState("saving");

      const articleId = docState.articleId;
      const desired = (docState.slug?.trim() || docState.title || "post");
      const finalSlug = await reserveUniqueSlug(db, articleId, desired);

      const ref = fsDoc(db, "articles", articleId);
      const payloadRaw = toArticleDoc({ ...docState, slug: finalSlug });
      const payload = sanitizeForFirestore(payloadRaw);

      await setDocFS(
        ref,
        {
          ...payload,
          status: "published",
          slug: finalSlug,
          publishedAt: serverTimestamp(),
          updatedAt: serverTimestamp(),

          // ลบ deletedAt ทิ้ง ถ้าเคยถูก archived มาก่อน
          deletedAt: null,
        },
        { merge: true }
      );

      // sync state ในหน้าให้กลายเป็น published ทันที
      setDocState((prev) => ({
        ...prev,
        slug: finalSlug,
        status: "published",
      }));

      // อัปเดต snapshot หลัง publish
      lastSavedSnapshot.current = buildPayloadNoTimestamps({ ...docState, slug: finalSlug, status: "published" });

      setSaveState("saved");
      setTimeout(() => setSaveState("idle"), 1200);
      alert("เผยแพร่บทความแล้ว\nslug = " + finalSlug);
    } catch (e) {
      console.error(e);
      setSaveState("error");
      alert("เผยแพร่ไม่สำเร็จ: " + (e?.message || "unknown"));
    } finally {
      suppressAutoSave.current = false;
    }
  };

  // Archive
  const archiveArticle = async () => {
  try {
    suppressAutoSave.current = true;
    setSaveState("saving");

    const ref = fsDoc(db, "articles", docState.articleId);
    await setDocFS(ref, {
      status: "archived",
      deletedAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    }, { merge: true });

    // อัปเดต snapshot
    lastSavedSnapshot.current = buildPayloadNoTimestamps({
      ...docState,
      status: "archived"
    });

    // อัปเดต UI บนหน้า
    setDocState((prev) => ({
      ...prev,
      status: "archived",
    }));

    setSaveState("saved");
    setTimeout(() => setSaveState("idle"), 1200);

    alert("ย้ายบทความไป Archived แล้ว");

  } catch (e) {
    console.error(e);
    setSaveState("error");
    alert("ย้ายไป Archived ไม่สำเร็จ: " + (e?.message || "unknown"));
  } finally {
    suppressAutoSave.current = false;
  }
  };

  const restoreFromArchived = async () => {
    try {
      suppressAutoSave.current = true;
      setSaveState("saving");

      const ref = fsDoc(db, "articles", docState.articleId);

      await setDocFS(
        ref,
        {
          status: "draft",          // กู้คืนมาเป็นฉบับร่าง
          deletedAt: null,          // ล้าง deletedAt ทิ้ง
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );

      const nextState = {
        ...docState,
        status: "draft",
        deletedAt: null,
      };

      setDocState(nextState);
      lastSavedSnapshot.current = buildPayloadNoTimestamps(nextState);

      setSaveState("saved");
      setTimeout(() => setSaveState("idle"), 1200);
      alert("กู้คืนบทความจาก Archived เป็นฉบับร่างแล้ว");
    } catch (e) {
      console.error(e);
      setSaveState("error");
      alert("กู้คืนบทความไม่สำเร็จ: " + (e?.message || "unknown"));
    } finally {
      suppressAutoSave.current = false;
    }
  };

  async function deleteArticleSubcollections(articleId) {
    // likes + bookmarks อยู่ใต้ /articles/{articleId}/...
    const likesRef = collection(db, "articles", articleId, "likes");
    const bookmarksRef = collection(db, "articles", articleId, "bookmarks");

    const batch = writeBatch(db);

    // ลบ likes
    const likesSnap = await getDocs(likesRef);
    likesSnap.forEach((docSnap) => {
      batch.delete(docSnap.ref);
    });

    // ลบ bookmarks
    const bookmarksSnap = await getDocs(bookmarksRef);
    bookmarksSnap.forEach((docSnap) => {
      batch.delete(docSnap.ref);
    });

    // ถ้าไม่มี doc ให้ลบ batch จะ commit แบบไม่มีอะไร ก็ไม่ error
    await batch.commit();
  }


  // Hard Delete
  const deleteArticleHard = async () => {
    try {
      suppressAutoSave.current = true;
      setSaveState("saving");

      const articleId = docState.articleId;
      const slug = (docState.slug || slugify(docState.title || "")).trim();

      // 1) ลบ subcollections likes + bookmarks ก่อน
      await deleteArticleSubcollections(articleId);

      // 2) ลบตัวบทความ + slugIndex ด้วย transaction (เหมือนเดิม)
      await runTransaction(db, async (tx) => {
        tx.delete(fsDoc(db, "articles", articleId));
        if (slug) tx.delete(fsDoc(db, "slugIndex", slug));
      });

      setSaveState("saved");
      setTimeout(() => setSaveState("idle"), 1200);
      alert("ลบถาวรเรียบร้อย");
      navigate("/account/creator/MyArticle");
    } catch (e) {
      console.error(e);
      setSaveState("error");
      alert("ลบถาวรไม่สำเร็จ: " + (e?.message || "unknown"));
    } finally {
      suppressAutoSave.current = false;
    }
  };

  const unpublishToDraft = async () => {
    try {
      suppressAutoSave.current = true;
      setSaveState("saving");

      const ref = fsDoc(db, "articles", docState.articleId);
      await setDocFS(
        ref,
        {
          status: "draft",
          updatedAt: serverTimestamp(),
          // publishedAt: null,  // ถ้าต้องการล้างค่า ก็ทำได้
        },
        { merge: true }
      );

      // sync state ในหน้า
      setDocState((prev) => ({
        ...prev,
        status: "draft",
        // ❌ publicStatus ไม่ต้องแตะ
      }));

      lastSavedSnapshot.current = buildPayloadNoTimestamps({
        ...docState,
        status: "draft",
        // ❌ publicStatus ไม่ต้องแตะ
      });

      setSaveState("saved");
      setTimeout(() => setSaveState("idle"), 1200);
      alert("ยกเลิกเผยแพร่แล้ว บทความกลับเป็นฉบับร่าง");
    } catch (e) {
      console.error(e);
      setSaveState("error");
      alert("ยกเลิกเผยแพร่ไม่สำเร็จ: " + (e?.message || "unknown"));
    } finally {
      suppressAutoSave.current = false;
    }
  };

  const handleBackToMyArticles = () => {
    // เช็กว่าเป็นบทความเผยแพร่แล้วไหม
    const isPublishedNow = docState.status === "published";

    // ถ้ายังไม่มี articleId เลย ก็ไม่ต้องเช็กอะไร
    if (!docState.articleId) {
      navigate("/account/creator/MyArticle");
      return;
    }

    // สร้าง snapshot ปัจจุบัน
    const currentSnapshot = buildPayloadNoTimestamps(docState);
    const prev = JSON.stringify(lastSavedSnapshot.current || {});
    const curr = JSON.stringify(currentSnapshot || {});

    const hasUnsavedChanges = prev !== curr;

    // ถ้าเป็นบทความเผยแพร่แล้ว และมีการแก้ไขที่ยังไม่บันทึก
    if (isPublishedNow && hasUnsavedChanges) {
      const ok = window.confirm(
        "มีการแก้ไขบทความที่ยังไม่ได้บันทึก\n\n" +
        "หากออกจากหน้านี้โดยไม่กด \"บันทึก\" การแก้ไขจะไม่ถูกบันทึก\n\n" +
        "ต้องการออกจากหน้านี้โดยไม่บันทึกหรือไม่?"
      );
      if (!ok) {
        // ผู้ใช้กด Cancel → อยู่หน้าปัจจุบันต่อ
        return;
      }
    }

    // ถ้าไม่มีการแก้ไข หรือไม่ใช่ published → ออกได้เลย
    navigate("/account/creator/MyArticle");
  };


  // แปลง document จาก Firestore ให้กลายเป็น state ของ ArticleEditor
  function fromFirestoreDoc(articleIdFromParam, data) {
    // map contentBlocks -> blocks
    const blocks = (data.contentBlocks || []).map((b, idx) => {
      const id = `b${idx + 1}`;

      switch (b.type) {
        case "heading":
          return {
            id,
            type: "heading",
            data: {
              level: b.level ?? 2,             
              text: b.text || "",
            },
          };

        case "paragraph":
          return {
            id,
            type: "paragraph",
            data: { text: b.text || "" },
          };

        case "image":
          return {
            id,
            type: "image",
            data: {
              imageUrl: b.src || "",
              alt: b.alt || b.caption || "",
            },
          };

      /*   case "code":
          return {
            id,
            type: "code",
            data: {
              language: b.language || "plaintext",
              code: b.code || "",
            },
          }; */


        case "quote":                     // ✅ เพิ่มเคสนี้
          return {
            id,
            type: "quote",
            data: {
              text: b.text || "",
              cite: b.cite || "",
            },
          };

        default:
          return {
            id,
            type: "paragraph",
            data: { text: "" },
          };
      }
    });

    return {
      articleId: data.articleId || articleIdFromParam,
      slug: data.slug || "",
      title: data.title || "",
      subtitle: data.subtitle || "",
      status: data.status || "draft",
      level: data.level || "general",

      // Firestore เป็น object {name, slug, categorySlug}
      category: data.category?.name || data.category || "",
      subCategory: data.subCategory?.name || data.subCategory || "",

      // Firestore มี tagSlugs / tagsDisplay → เลือกมาอย่างใดอย่างหนึ่งเป็น tags
       // Firestore มี tagSlugs / tagsDisplay → ใช้ tagsDisplay เป็นหลักสำหรับ UI
      tags: data.tagsDisplay || data.tagSlugs || [],
      author: data.author || { uid: "", displayName: "" },

      // Firestore: cover = string URL + coverCaption
      cover: {
        imageUrl:
          (typeof data.cover === "string" ? data.cover : data.cover?.imageUrl) || "",
        alt: data.coverCaption || data.cover?.alt || "",
        width: data.cover?.width,
        height: data.cover?.height,
      },

      blocks,
      readTime: data.readTime || 0,
      wordCount: data.wordCount || 0,
      publicStatus: data.publicStatus ?? (data.status === "published"),
      createdAt: data.createdAt || null,
      updatedAt: data.updatedAt || null,
      // ✅ ดึงจาก Firestore มาเก็บใน state
      views: data.views ?? 0,
      likesCount: data.likesCount ?? 0,
      bookmarksCount: data.bookmarksCount ?? 0,
    };
  }

  const isPublished = docState.status === "published";
  const isArchived = docState.status === "archived";

  const [statusConfirm, setStatusConfirm] = useState(null);

  const handleStatusChangeRequest = (nextStatus) => {
    const current = docState.status;
    if (nextStatus === current) return;

    if (current === "draft" && nextStatus === "published") {
      setStatusConfirm({ from: "draft", to: "published" });
    } else if (current === "published" && nextStatus === "draft") {
      setStatusConfirm({ from: "published", to: "draft" });
    }
    // อย่างอื่น (เช่น archived) เราไม่รองรับจาก dropdown อยู่แล้ว
  };

  return (
    <Container>
      {/* Toolbar */}
      <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center mb-3">
        {/* badges */}
        <div className="d-flex align-items-center gap-2 me-md-auto mb-2 mb-md-0">
            <span className="badge text-bg-secondary">Article ID: {docState.articleId}</span>
            <span className="badge text-bg-info">Words: {wordCount}</span>
            <span className="badge text-bg-warning">Read: ~{readTime} นาที</span>
            <SaveIndicator state={saveState} isPublished={isPublished} isArchived={isArchived} />
        </div>

        {/* buttons */}
        <div className="d-flex gap-2 w-100 w-md-auto justify-content-start justify-content-md-end ms-0 ms-md-auto">
            {/* <button className="btn btn-outline-secondary btn-sm" onClick={onSaveDraft}>
            Save Draft
            </button> */}
            <button
              className="btn btn-outline-info btn-sm"
              onClick={handleBackToMyArticles}
            >
              ← บทความของฉัน
            </button>
            <button className="btn btn-outline-secondary btn-sm" onClick={onSaveDraft}>
            {isPublished ? "บันทึก" : "บันทึกร่าง"}
            </button>
            <button className="btn btn-outline-primary btn-sm" onClick={() => setShowPreview(true)}>
            Preview
            </button>
            {/* <button className="btn btn-primary btn-sm" onClick={onPublish}>
            Publish
            </button> */}
            {/* แสดงปุ่ม Publish เฉพาะตอนยังไม่ published */}
            {/* {!isPublished && (
              <button className="btn btn-primary btn-sm" onClick={onPublish}>
                Publish
              </button>
            )} */}
            {!isPublished && !isArchived && (
              <button
                className="btn btn-primary btn-sm"
                onClick={() => setStatusConfirm({ from: docState.status, to: "published" })}
              >
                Publish
              </button>
            )}

            {/* กลุ่มลบ */}
            <div className="btn-group">
            <button
              className="btn btn-outline-danger btn-sm dropdown-toggle"
              data-bs-toggle="dropdown"
            >
              Delete
            </button>
            <ul className="dropdown-menu dropdown-menu-end">
              {isArchived ? (
                // กรณีอยู่ในสถานะ archived → ให้แสดง Restore
                <li>
                  <button
                    className="dropdown-item text-success"
                    onClick={() => setShowRestoreConfirm(true)}
                  >
                    Restore Article
                  </button>
                </li>
              ) : (
                // กรณี draft/published → ใช้ Move to Archived ตามเดิม
                <li>
                  <button
                    className="dropdown-item text-warning"
                    onClick={() => setShowArchiveConfirm(true)}
                  >
                    Move to Archived
                  </button>
                </li>
              )}

              <li><hr className="dropdown-divider" /></li>
              <li>
                <button
                  className="dropdown-item text-danger"
                  onClick={() => setShowDeleteConfirm(true)}
                >
                  Delete permanently…
                </button>
              </li>
            </ul>
          </div>


            {/* <div className="btn-group">
              <button className="btn btn-outline-danger btn-sm dropdown-toggle" data-bs-toggle="dropdown">
                Delete
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button className="dropdown-item text-warning" onClick={() => setShowArchiveConfirm(true)}>
                    Move to Archived
                  </button>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <button className="dropdown-item text-danger" onClick={() => setShowDeleteConfirm(true)}>
                    Delete permanently…
                  </button>
                </li>
              </ul>
            </div> */}
        </div>

         
    </div>

      <div className="row g-3">
        {/* Main Editor */}
        <div className="col-lg-8">
          <MainEditor
            blocks={docState.blocks}
            onAddBlock={addBlock}
            onUpdateBlock={updateBlock}
            onRemoveBlock={removeBlock}
            onMoveBlock={moveBlock}
          />
        </div>

        {/* Sidebar Metadata */}
        <div className="col-lg-4">
          <MetadataSidebar doc={docState} onChange={updateField} onStatusChangeRequest={handleStatusChangeRequest} />
        </div>
      </div>

      {/* Preview Modal */}
      {showPreview && (
        <PreviewModal onClose={() => setShowPreview(false)} title={docState.title} subtitle={docState.subtitle} cover={docState.cover} blocks={docState.blocks} />
      )}

      {showArchiveConfirm && (
        <ConfirmModal
          title="Move to Archived?"
          body="บทความจะถูกย้ายไปสถานะ Archived และซ่อนไม่ให้แสดงต่อสาธารณะ แต่ยังสามารถกู้คืนภายหลังได้"
          confirmText="Move to Archived"
          variant="warning"
          onClose={() => setShowArchiveConfirm(false)}
          onConfirm={async () => { setShowArchiveConfirm(false); await archiveArticle(); }}
        />
      )}

      {showDeleteConfirm && (
        <ConfirmModal
          title="Delete permanently?"
          body="การลบถาวรจะลบเอกสารบทความทันที และปลดจอง slug ใน slugIndex (หากมี) การกระทำนี้ย้อนกลับไม่ได้"
          confirmText="Delete permanently"
          variant="danger"
          onClose={() => setShowDeleteConfirm(false)}
          onConfirm={async () => { setShowDeleteConfirm(false); await deleteArticleHard(); }}
        />
      )}

      {/* {statusConfirm && statusConfirm.from === "draft" && statusConfirm.to === "published" && (
        <ConfirmModal
          title="เผยแพร่บทความ?"
          body="คุณต้องการเผยแพร่บทความนี้หรือไม่"
          confirmText="ตกลง"
          variant="primary"
          onClose={() => setStatusConfirm(null)}
          onConfirm={async () => {
            setStatusConfirm(null);
            await onPublish();      // ใช้ฟังก์ชัน publish เดิม
          }}
        />
      )} */}
      {statusConfirm &&
      statusConfirm.to === "published" &&         // เป้าหมายคือ published
      statusConfirm.from !== "published" && (     // มาจาก draft หรือ archived
        <ConfirmModal
          title="เผยแพร่บทความ?"
          body={
            statusConfirm.from === "archived"
              ? "บทความนี้อยู่ในสถานะจัดเก็บ (Archived) ต้องการเผยแพร่อีกครั้งหรือไม่"
              : "คุณต้องการเผยแพร่บทความนี้หรือไม่"
          }
          confirmText="ตกลง"
          variant="primary"
          onClose={() => setStatusConfirm(null)}
          onConfirm={async () => {
            setStatusConfirm(null);
            await onPublish();   // ใช้ฟังก์ชัน publish เดิม (จัดการ slug/publishedAt ฯลฯ)
          }}
        />
      )}

      {statusConfirm && statusConfirm.from === "published" && statusConfirm.to === "draft" && (
        <ConfirmModal
          title="ยกเลิกการเผยแพร่?"
          body="คุณต้องการยกเลิกเผยแพร่บทความนี้และเปลี่ยนเป็นฉบับร่างหรือไม่"
          confirmText="ตกลง"
          variant="warning"
          onClose={() => setStatusConfirm(null)}
          onConfirm={async () => {
            setStatusConfirm(null);
            await unpublishToDraft();   // ฟังก์ชันใหม่
          }}
        />
      )}

      {showRestoreConfirm && (
        <ConfirmModal
          title="Restore article?"
          body="ต้องการกู้คืนบทความนี้จากสถานะ Archived เป็นฉบับร่างหรือไม่"
          confirmText="Restore"
          variant="warning"
          onClose={() => setShowRestoreConfirm(false)}
          onConfirm={async () => {
            setShowRestoreConfirm(false);
            await restoreFromArchived();
          }}
        />
      )}

      <style>{customStyles}</style>
    </Container>
  );
}

// ================= Components ================= //

function SaveIndicator({ state, isPublished, isArchived }) {

  // === กรณี 'published' ===
  if (isPublished) {
    return (
      <span className="small text-success fw-semibold text-nowrap">
        สถานะ : เผยแพร่
      </span>
    );
  }

  // === กรณี 'archived' ===
  if (isArchived) {
    return (
      <span className="small text-primary fw-semibold text-nowrap">
        สถานะ : จัดเก็บแล้ว
      </span>
    );
  }

  // === draft → แสดง autosave options ตามเดิม ===
  if (state === "saving")
    return <span className="small text-muted text-nowrap">กำลังบันทึก…</span>;

  if (state === "saved")
    return <span className="small text-success text-nowrap">บันทึกแล้ว</span>;

  if (state === "error")
    return <span className="small text-danger text-nowrap">บันทึกผิดพลาด</span>;

  return (
    <span className="small text-muted text-nowrap">
      พร้อมบันทึกอัตโนมัติ
    </span>
  );
}


function MainEditor({ blocks = [], onAddBlock, onUpdateBlock, onRemoveBlock, onMoveBlock }) {
  return (
    <div className="card shadow-sm">
      <div className="card-header d-flex justify-content-between align-items-center">
        <strong>Content Blocks</strong>
        <div className="btn-group">
          <button className="btn btn-sm btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown">
            + Add Block
          </button>
          <ul className="dropdown-menu dropdown-menu-end">
            {[
              { t: "Heading", v: "heading" },
              { t: "Paragraph", v: "paragraph" },
              { t: "Image", v: "image" },
              // { t: "Code", v: "code" },
              { t: "Quote", v: "quote" },
            ].map((opt) => (
              <li key={opt.v}>
                <button className="dropdown-item" onClick={() => onAddBlock(opt.v)}>
                  {opt.t}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="card-body">
        {blocks.length === 0 && (
          <div className="text-center text-muted py-5">ยังไม่มีบล็อก เพิ่มด้วยปุ่ม "+ Add Block"</div>
        )}

        <div className="vstack gap-3">
          {blocks.map((block) => (
            <BlockItem
              key={block.id}
              block={block}
              onUpdate={(patch) => onUpdateBlock(block.id, patch)}
              onRemove={() => onRemoveBlock(block.id)}
              onMoveUp={() => onMoveBlock(block.id, "up")}
              onMoveDown={() => onMoveBlock(block.id, "down")}
            />)
          )}


          {/* ปุ่ม Add Block ด้านล่างสุด */}
          <div className="text-end mt-3">
            <div className="btn-group">
              <button className="btn btn-sm btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown">
                + Add Block
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                {[ 
                  { t: "Heading", v: "heading" },
                  { t: "Paragraph", v: "paragraph" },
                  { t: "Image", v: "image" },
                  // { t: "Code", v: "code" },
                  { t: "Quote", v: "quote" },
                ].map((opt) => (
                  <li key={opt.v}>
                    <button className="dropdown-item" onClick={() => onAddBlock(opt.v)}>
                      {opt.t}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

function BlockItem({ block, onUpdate, onRemove, onMoveUp, onMoveDown }) {
  return (
    <div className="border rounded p-3 block-item">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex align-items-center gap-2">
          <span className="badge text-bg-light text-uppercase">{block.type}</span>
        </div>
        <div className="btn-group btn-group-sm">
          <button className="btn btn-outline-secondary" title="Move up" onClick={onMoveUp}>
            ↑
          </button>
          <button className="btn btn-outline-secondary" title="Move down" onClick={onMoveDown}>
            ↓
          </button>
          <button className="btn btn-outline-danger" title="Delete" onClick={onRemove}>
            ลบ
          </button>
        </div>
      </div>

      {block.type === "heading" && <HeadingBlock data={block.data} onChange={(data) => onUpdate({ data })} />}
      {block.type === "paragraph" && <ParagraphBlock data={block.data} onChange={(data) => onUpdate({ data })} />}
      {block.type === "image" && <ImageBlock data={block.data} onChange={(data) => onUpdate({ data })} />}
      {block.type === "code" && <CodeBlock data={block.data} onChange={(data) => onUpdate({ data })} />}
      {block.type === "quote" && <QuoteBlock data={block.data} onChange={(data) => onUpdate({ data })} />}
    </div>
  );
}

function HeadingBlock({ data, onChange }) {
  return (
    <div className="row g-2">
      <div className="col-3 col-md-2">
        <label className="form-label">Level</label>
        <select
          className="form-select"
          value={data.level || 2}
          onChange={(e) => onChange({ ...data, level: Number(e.target.value) })}
        >
          {[1, 2, 3, 4, 5, 6].map((lv) => (
            <option key={lv} value={lv}>
              H{lv}
            </option>
          ))}
        </select>
      </div>
      <div className="col-9 col-md-10">
        <label className="form-label">หัวข้อ</label>
        <input
          type="text"
          className="form-control"
          value={data.text || ""}
          onChange={(e) => onChange({ ...data, text: e.target.value })}
          placeholder="พิมพ์หัวข้อ..."
        />
      </div>
    </div>
  );
}

function ParagraphBlock({ data, onChange }) {
  return (
    <div>
      <label className="form-label">ย่อหน้า</label>
      <textarea
        className="form-control"
        rows={4}
        value={data.text || ""}
        onChange={(e) => onChange({ ...data, text: e.target.value })}
        placeholder="พิมพ์ข้อความ... ใช้ \n เพื่อขึ้นบรรทัดใหม่"
      />
    </div>
  );
}

/* function ImageBlock({ data, onChange }) {
  return (
    <div className="row g-2">
      <div className="col-12">
        <label className="form-label">Image URL</label>
        <input
          type="url"
          className="form-control"
          value={data.imageUrl || ""}
          onChange={(e) => onChange({ ...data, imageUrl: e.target.value })}
          placeholder="https://..."
        />
      </div>
      <div className="col-12">
        <label className="form-label">Alt text</label>
        <input
          type="text"
          className="form-control"
          value={data.alt || ""}
          onChange={(e) => onChange({ ...data, alt: e.target.value })}
          placeholder="คำอธิบายรูปภาพ (เพื่อ SEO/Accessibility)"
        />
      </div>
      {data.imageUrl && (
        <div className="col-12 mt-2">
          <div className="ratio ratio-16x9 border rounded overflow-hidden">
            <img src={data.imageUrl} alt={data.alt || "preview"} style={{ objectFit: "cover" }} />
          </div>
        </div>
      )}
    </div>
  );
} */

function ImageBlock({ data, onChange }) {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      setProgress(0);
      const url = await uploadImage(
        file,
        "articles/blocks/",
        (p) => setProgress(p)
      );
      onChange({ ...data, imageUrl: url });
      alert("อัปโหลดสำเร็จ!");
    } catch (err) {
      console.error(err);
      alert("อัปโหลดไม่สำเร็จ: " + err.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="row g-2">
      <div className="col-12">
        <label className="form-label">Image URL</label>
        <div className="input-group">
          <input
            type="url"
            className="form-control"
            value={data.imageUrl || ""}
            onChange={(e) =>
              onChange({ ...data, imageUrl: e.target.value })
            }
            placeholder="https://..."
          />
          <label className="btn btn-outline-secondary mb-0">
            <BsUpload /> Upload
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={handleFile}
              disabled={uploading}
            />
          </label>
        </div>

        {uploading && (
          <div className="progress mt-2">
            <div
              className="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              style={{ width: `${progress}%` }}
            >
              {progress}%
            </div>
          </div>
        )}
      </div>

      <div className="col-12">
        <label className="form-label">Alt text</label>
        <input
          type="text"
          className="form-control"
          value={data.alt || ""}
          onChange={(e) =>
            onChange({ ...data, alt: e.target.value })
          }
          placeholder="คำอธิบายรูปภาพ (เพื่อ SEO/Accessibility)"
        />
      </div>

      {data.imageUrl && (
        <div className="col-12 mt-2">
          <div className="ratio ratio-16x9 border rounded overflow-hidden">
            <img
              src={data.imageUrl}
              alt={data.alt || "preview"}
              style={{ objectFit: "cover" }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

function CodeBlock({ data, onChange }) {
  return (
    <div className="row g-2">
      <div className="col-md-4">
        <label className="form-label">Language</label>
        <select
          className="form-select"
          value={data.language || "plaintext"}
          onChange={(e) => onChange({ ...data, language: e.target.value })}
        >
          {["plaintext", "javascript", "typescript", "python", "bash", "json", "html", "css"].map((lang) => (
            <option key={lang} value={lang}>
              {lang}
            </option>
          ))}
        </select>
      </div>
      <div className="col-12">
        <label className="form-label">Code</label>
        <textarea
          className="form-control code-textarea"
          rows={8}
          value={data.code || ""}
          onChange={(e) => onChange({ ...data, code: e.target.value })}
          placeholder="วางโค้ดที่นี่..."
        />
      </div>
    </div>
  );
}

function QuoteBlock({ data, onChange }) {
  return (
    <div className="row g-2">
      <div className="col-12">
        <label className="form-label">ข้อความ</label>
        <textarea
          className="form-control"
          rows={3}
          value={data.text || ""}
          onChange={(e) => onChange({ ...data, text: e.target.value })}
          placeholder="ใส่คำคม/ข้อความอ้างอิง"
        />
      </div>
      <div className="col-md-6">
        <label className="form-label">ผู้กล่าวอ้าง/ที่มา</label>
        <input
          className="form-control"
          value={data.cite || ""}
          onChange={(e) => onChange({ ...data, cite: e.target.value })}
          placeholder="เช่น ChicChic Team / ชื่อติวเตอร์"
        />
      </div>
    </div>
  );
}


function MetadataSidebar({ doc, onChange, onStatusChangeRequest }) {
  const [tagInput, setTagInput] = useState("");

  // >>> เพิ่ม state สำหรับอัปโหลดรูป cover
  const [uploadingCover, setUploadingCover] = useState(false);
  const [coverProgress, setCoverProgress] = useState(0);

  // เพิ่ม state สำหรับ “อื่นๆ …”
  const [useCustomCategory, setUseCustomCategory] = useState(
    !!doc.category && !Object.keys(CATEGORIES).includes(doc.category)
  );
  const [useCustomSub, setUseCustomSub] = useState(
    !!doc.subCategory &&
      !!doc.category &&
      Array.isArray(CATEGORIES[doc.category]) &&
      !CATEGORIES[doc.category]?.includes(doc.subCategory)
  );

  const pushTag = () => {
    const t = tagInput.trim();
    if (!t) return;
    const next = Array.from(new Set([...(doc.tags || []), t]));
    onChange({ tags: next });
    setTagInput("");
  };

  const removeTag = (t) => onChange({ tags: (doc.tags || []).filter((x) => x !== t) });

  const onTitleChange = (value) => {
    onChange({ title: value, slug: slugify(value) });
  };

  // ====== Helpers สำหรับ Category / SubCategory ======
  const categoryList = Object.keys(CATEGORIES);
  const subList = CATEGORIES[doc.category] || [];

  const handleCategoryChange = (e) => {
    const value = e.target.value;

    if (value === OTHER_VALUE) {
      setUseCustomCategory(true);
      // เคลียร์ค่า category/subCategory เพื่อให้ผู้ใช้พิมพ์ใหม่
      onChange({ category: "", subCategory: "" });
      setUseCustomSub(true); // เมื่อใช้หมวดเอง กำหนดให้ซับหมวดเป็น custom ด้วย
      return;
    }

    setUseCustomCategory(false);
    setUseCustomSub(false);

    // ถ้าเปลี่ยนหมวด แล้วซับหมวดเดิมไม่อยู่ในลิสต์ใหม่ → เคลียร์
    const next = { category: value };
    if (!CATEGORIES[value]?.includes(doc.subCategory)) {
      next.subCategory = "";
    }
    onChange(next);
  };

  const handleSubChange = (e) => {
    const value = e.target.value;
    if (value === OTHER_VALUE) {
      setUseCustomSub(true);
      onChange({ subCategory: "" });
      return;
    }
    setUseCustomSub(false);
    onChange({ subCategory: value });
  };

  // >>> ฟังก์ชันอัปโหลดรูป cover
  const handleCoverFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setUploadingCover(true);
      setCoverProgress(0);

      // โฟลเดอร์เก็บภาพ cover (ปรับ path ได้ตามต้องการ)
      const url = await uploadImage(file, "articles/covers/", (p) => setCoverProgress(p));

      // อัปเดต imageUrl ลง cover
      onChange({ cover: { ...(doc.cover || {}), imageUrl: url } });

      // (ออปชัน) ดึงขนาดรูปเก็บลง width/height
      const img = new Image();
      img.onload = () => {
        onChange({
          cover: {
            ...(doc.cover || {}),
            imageUrl: url,
            width: img.naturalWidth,
            height: img.naturalHeight,
          },
        });
      };
      img.src = url;

      alert("อัปโหลดรูปหน้าปกสำเร็จ!");
    } catch (err) {
      console.error(err);
      alert("อัปโหลดไม่สำเร็จ: " + (err?.message || "unknown"));
    } finally {
      setUploadingCover(false);
    }
  };

  return (
    <div className="card shadow-sm">
      <div className="card-header">
        <strong>Metadata</strong>
      </div>
      <div className="card-body">
        <div className="mb-3">
          <label className="form-label">ชื่อบทความ</label>
          <input className="form-control" value={doc.title} onChange={(e) => onTitleChange(e.target.value)} />
        </div>
         {/* ✅ Subtitle / คำอธิบายใต้หัวข้อ */}
        <div className="mb-3">
          <label className="form-label">คำอธิบายใต้หัวข้อ (Subtitle)</label>
          <textarea
            className="form-control"
            rows={2}
            placeholder="สรุปสั้น ๆ ว่าบทความนี้ให้ประโยชน์อะไร ..."
            value={doc.subtitle || ""}
            onChange={(e) => onChange({ subtitle: e.target.value })}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Slug</label>
          <input className="form-control" value={doc.slug} onChange={(e) => onChange({ slug: e.target.value })} />
        </div>
        {/* Category / SubCategory: ใช้ Dropdown */}
        <div className="row g-2 mb-3">
          <div className="col-md-6">
            <label className="form-label">หมวดหมู่</label>
            {!useCustomCategory ? (
              <select
                className="form-select"
                value={categoryList.includes(doc.category) ? doc.category : ""}
                onChange={handleCategoryChange}
              >
                <option value="" disabled>-- เลือกหมวดหมู่ --</option>
                {categoryList.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
                <option value={OTHER_VALUE}>อื่นๆ … (กำหนดเอง)</option>
              </select>
            ) : (
              <div className="input-group">
                <input
                  className="form-control"
                  placeholder="พิมพ์หมวดหมู่เอง…"
                  value={doc.category || ""}
                  onChange={(e) => onChange({ category: e.target.value })}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => {
                    // ถ้าผู้ใช้กลับมาเลือกจากลิสต์
                    setUseCustomCategory(false);
                    // เคลียร์ sub ถ้าไม่ตรงกับลิสต์ใหม่
                    if (!CATEGORIES[doc.category]?.includes(doc.subCategory)) {
                      onChange({ subCategory: "" });
                    }
                  }}
                  title="เปลี่ยนเป็นเลือกรายการจากลิสต์"
                >
                  เลือกจากลิสต์
                </button>
              </div>
            )}
          </div>

          <div className="col-md-6">
            <label className="form-label">หมวดย่อย</label>
            {/* ถ้ายังไม่เลือกหมวดหมู่ → disable */}
            {!useCustomSub && !useCustomCategory ? (
              <select
                className="form-select"
                value={subList.includes(doc.subCategory) ? doc.subCategory : ""}
                onChange={handleSubChange}
                disabled={!doc.category}
              >
                <option value="" disabled>-- เลือกหมวดย่อย --</option>
                {subList.map((s) => (
                  <option key={s} value={s}>{s}</option>
                ))}
                <option value={OTHER_VALUE}>อื่นๆ … (กำหนดเอง)</option>
              </select>
            ) : (
              <div className="input-group">
                <input
                  className="form-control"
                  placeholder="พิมพ์หมวดย่อยเอง…"
                  value={doc.subCategory || ""}
                  onChange={(e) => onChange({ subCategory: e.target.value })}
                  disabled={!doc.category && !useCustomCategory}
                />
                {!!doc.category && (
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setUseCustomSub(false)}
                    title="เปลี่ยนเป็นเลือกรายการจากลิสต์"
                  >
                    เลือกจากลิสต์
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="mb-2">
          <label className="form-label">Tags</label>
          <div className="input-group">
            <input
              className="form-control"
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              placeholder="พิมพ์แล้วกด +"
              onKeyDown={(e) => e.key === "Enter" && pushTag()}
            />
            <button className="btn btn-outline-secondary" onClick={pushTag}>
              +
            </button>
          </div>
          <div className="mt-2 d-flex flex-wrap gap-2">
            {(doc.tags || []).map((t) => (
              <span key={t} className="badge text-bg-light">
                {t} <button className="btn btn-sm btn-link p-0 ms-1" onClick={() => removeTag(t)}>×</button>
              </span>
            ))}
          </div>
        </div>

        <div className="mb-3">
          <label className="form-label">ระดับความยากของบทความ</label>
          <select
            className="form-select"
            value={doc.level || "general"}
            onChange={(e) => onChange({ level: e.target.value })}
          >
            <option value="general">ทั่วไป</option>
            <option value="beginner">Beginner</option>
            <option value="intermediate">Intermediate</option>
            <option value="advanced">Advanced</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">สถานะ</label>
          {/* <select className="form-select" value={doc.status} onChange={(e) => onChange({ status: e.target.value })}>
            <option value="draft">draft</option>
            <option value="published">published</option>
            <option value="archived">archived</option>
          </select> */}
          {doc.status === "archived" ? (
            // ถ้าเป็น archived แล้ว → ให้แสดงว่า archived อย่างเดียว แก้จาก dropdown นี้ไม่ได้
            <select className="form-select" value="archived" disabled>
              <option value="archived">archived</option>
            </select>
          ) : (
            // กรณี draft / published → ให้เลือกได้เฉพาะสองสถานะนี้
            <select
              className="form-select"
              value={doc.status}
              onChange={(e) => onStatusChangeRequest(e.target.value)}
            >
              <option value="draft">draft</option>
              <option value="published">published</option>
            </select>
          )}
        </div>

        <div className="mb-3">
          <label className="form-label">ผู้เขียน</label>
          <input className="form-control" value={doc.author?.displayName || ""} onChange={(e) => onChange({ author: { ...doc.author, displayName: e.target.value } })} />
        </div>

        {/* Cover Image with Upload */}
        <div className="mb-3">
          <label className="form-label">Cover Image URL</label>
          <div className="input-group">
            <input
              className="form-control"
              value={doc.cover?.imageUrl || ""}
              onChange={(e) => onChange({ cover: { ...(doc.cover || {}), imageUrl: e.target.value } })}
              placeholder="https://..."
            />
            <label className="btn btn-outline-secondary mb-0">
              <BsUpload /> Upload
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleCoverFile}
                disabled={uploadingCover}
              />
            </label>
          </div>

          {uploadingCover && (
            <div className="progress mt-2">
              <div
                className="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
                style={{ width: `${coverProgress}%` }}
              >
                {coverProgress}%
              </div>
            </div>
          )}

          {doc.cover?.imageUrl && (
            <div className="mt-2 ratio ratio-16x9 border rounded overflow-hidden">
              <img
                src={doc.cover.imageUrl}
                alt={doc.cover.alt || "cover"}
                style={{ objectFit: "cover" }}
                onLoad={(e) => {
                  // (ออปชัน) sync ขนาดรูปหากยังไม่ถูกตั้ง
                  const w = e.currentTarget.naturalWidth;
                  const h = e.currentTarget.naturalHeight;
                  if (!doc.cover?.width || !doc.cover?.height) {
                    onChange({ cover: { ...(doc.cover || {}), width: w, height: h } });
                  }
                }}
              />
            </div>
          )}
           {/* ✅ ช่องกรอกคำอธิบายใต้รูปหน้าปก */}
            <div className="mt-2">
              <label className="form-label">
                คำอธิบายใต้รูปหน้าปก (Cover caption)
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="เช่น ไม่มี Midjourney จะร่างตัวละครไทยได้ดีในระดับหนึ่ง..."
                value={doc.cover?.alt || ""}
                onChange={(e) =>
                  onChange({
                    cover: { ...(doc.cover || {}), alt: e.target.value },
                  })
                }
              />
            </div>
        </div>

         {/* แถวแรก: Views / Likes / Bookmarks */}
        <div className="row g-2 mb-2">
          <div className="col-md-4">
            <label className="form-label">Views</label>
            <input
              className="form-control"
              value={doc.views ?? 0}
              readOnly
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Likes</label>
            <input
              className="form-control"
              value={doc.likesCount ?? 0}
              readOnly
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Bookmarks</label>
            <input
              className="form-control"
              value={doc.bookmarksCount ?? 0}
              readOnly
            />
          </div>
        </div>

        <div className="row g-2">
          <div className="col-md-6">
            <label className="form-label">Word Count</label>
            <input className="form-control" value={doc.wordCount} readOnly />
          </div>
          <div className="col-md-6">
            <label className="form-label">Read Time (min)</label>
            <input className="form-control" value={doc.readTime} readOnly />
          </div>
        </div>
      </div>
    </div>
  );
}

function PreviewModal({ onClose, title, subtitle, cover, blocks }) {
  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-xl" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Preview</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <article className="container">
              <h1 className="mb-3">{title}</h1>
              {/* ✅ แสดง subtitle ถ้ามี */}
              {subtitle && (
                <p className="text-muted lead mb-3">
                  {subtitle}
                </p>
              )}
              {cover?.imageUrl && (
                <figure className="mb-3">
                  <div className="ratio ratio-16x9">
                    <img
                      src={cover.imageUrl}
                      alt={cover.alt || "cover"}
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                  {cover.alt && (
                    <figcaption className="text-muted small mt-1">
                      {cover.alt}
                    </figcaption>
                  )}
                </figure>
              )}
              <ArticleRenderer blocks={blocks} />
            </article>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ===== Read-only Renderer (same idea as production reader) =====
function ArticleRenderer({ blocks }) {
  return (
    <div className="vstack gap-3">
      {blocks.map((b) => {
        switch (b.type) {
          case "heading": {
            const H = `h${b.data.level || 2}`;
            return (
              <H key={b.id} className="fw-semibold mt-4">
                {b.data.text}
              </H>
            );
          }
          case "paragraph":
            return (
              <p key={b.id} className="mb-1">
                {breakLines(b.data.text)}
              </p>
            );
          case "image":
            return (
              <figure key={b.id} className="m-0">
                <img src={b.data.imageUrl} alt={b.data.alt || ""} className="img-fluid rounded shadow-sm" />
                {b.data.alt && <figcaption className="text-muted small mt-1">{b.data.alt}</figcaption>}
              </figure>
            );
          case "quote":
            return (
              <blockquote key={b.id} className="blockquote border-start ps-3">
                <p className="mb-0">{b.data.text}</p>
                {b.data.cite && <footer className="blockquote-footer mt-1">{b.data.cite}</footer>}
              </blockquote>
            );
          case "code":
            return (
              <pre key={b.id} className="bg-light p-3 rounded overflow-auto">
                <code>{b.data.code}</code>
              </pre>
            );
          default:
            return null;
        }
      })}
    </div>
  );
}

// ================= Utils & Styles ================= //

function calcWordCountTHAware(blocks = []) {
  const text = blocks.map(b => {
    if (b.type === "heading") return b.data?.text || "";
    if (b.type === "paragraph") return b.data?.text || "";
    if (b.type === "quote") return b.data?.text || "";
    if (b.type === "code") return b.data?.code || "";
    return "";
  }).join(" ");

  // ถ้ามี Segmenter (เบราว์เซอร์ใหม่ๆ)
  if (typeof Intl !== "undefined" && Intl.Segmenter) {
    const seg = new Intl.Segmenter("th", { granularity: "word" });
    let count = 0;
    for (const s of seg.segment(text)) {
      if (s.isWordLike) count++;
    }
    return count;
  }

  // fallback เดิม (เหมาะกับภาษาอังกฤษ)
  return (text.match(/\b\w+\b/giu) || []).length;
}


function calcWordCount(blocks = []) {
  const text = blocks
    .map((b) => {
      if (b.type === "heading") return b.data?.text || "";
      if (b.type === "paragraph") return b.data?.text || "";
      if (b.type === "quote") return b.data?.text || "";
      if (b.type === "code") return b.data?.code || "";
      return "";
    })
    .join(" ");
  return (text.match(/\b\w+\b/giu) || []).length;
}

function breakLines(text = "") {
  return text.split("\n").map((line, i) => (
    <span key={i}>
      {line}
      <br />
    </span>
  ));
}

function slugify(str = "") {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

function ConfirmModal({ title, body, confirmText, variant = "danger", onClose, onConfirm }) {
  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p className="mb-0">{body}</p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button className={`btn btn-${variant}`} onClick={onConfirm}>
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

const customStyles = `
.block-item:hover { background: #fafafa; }
.code-textarea { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }
.modal { background: rgba(0,0,0,.35); }
`;
